import { faPrint } from "@fortawesome/pro-light-svg-icons";
import { type PropsWithChildren } from "react";

import { T } from "@repo/transifex";

import { Modal } from "../../shared/modal";
import { ModalIcon } from "../../shared/modal-icon";
import { ModalTitle } from "../../shared/modal-title";

export const ModalPrintingLoading = ({ children }: PropsWithChildren) => {
  return (
    <Modal backdropVariant="success">
      <div className="flex flex-col items-center gap-y-16">
        <ModalIcon icon={faPrint} />

        <ModalTitle size="8xl" variant="normal" weight="black">
          <T _str="Printing receipt" />
        </ModalTitle>

        <p className="text-5xl font-extralight text-kiosk-text-primary">
          <T _str="Please wait..." />
        </p>

        {children}
      </div>
    </Modal>
  );
};
